module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e06143c5dc2e8bb30e70a8ab9d2cc621.png";